import Seo from "@/components/Seo";

export default function About() {
  return (
    <>
      <Seo title="About — Fitness Calculator" description="About Fitness Calculator — a free, fast, privacy-friendly hub of 32 health & fitness calculators." path="/about" />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-16 space-y-6">
        <h1 className="text-4xl font-bold tracking-tight">About Fitness Calculator</h1>
        <p className="text-muted-foreground text-lg leading-relaxed">
          Fitness Calculator is a free, no-sign-up hub of 32 carefully-built health and fitness calculators — from BMI and TDEE to pregnancy tracking and 1RM predictions.
        </p>
        <p className="text-muted-foreground leading-relaxed">
          Our mission is simple: give people a clean, fast, mobile-friendly place to answer the everyday questions they have about their bodies, workouts and nutrition — without ads plastered everywhere and without dark patterns.
        </p>
        <h2 className="text-2xl font-bold pt-4">How we're different</h2>
        <ul className="list-disc pl-6 text-muted-foreground space-y-2">
          <li><strong className="text-foreground">Instant results.</strong> Every calculation runs in your browser — no waiting, no data sent anywhere.</li>
          <li><strong className="text-foreground">Formulas you can trust.</strong> We link the equations used on every page so you can verify the math.</li>
          <li><strong className="text-foreground">Mobile-first.</strong> Big tap targets, numeric keyboards and a fast, app-like feel.</li>
          <li><strong className="text-foreground">Privacy.</strong> We don't collect your inputs. Nothing to sign up for.</li>
        </ul>
        <p className="text-sm text-muted-foreground pt-6">
          The information provided is for educational purposes only and is not a substitute for professional medical advice.
        </p>
      </div>
    </>
  );
}
